/* eslint-disable camelcase */
import actions from '@codehq/aurora-app-core/src/store/modules/auth/actions';
import axios from 'axios';

const customActions = {
  // eslint-disable-next-line no-unused-vars
  async ADMIN_REGISTER_auth({ commit }, data) {
    // strange quirk where the baseURL is not persisted
    const { username, email, password } = data;
    const result = await axios.post('/join/admin-register', {
      phoneNumber: username,
      email,
      password,
    });
    return result;
  },
};

export default { ...actions, ...customActions };
